import useProductsMap from './useProductsMap';
export default function useModuleProducts(module) {
  var productsMap = useProductsMap();
  return productsMap[module] || [];
}